import { Children, isValidElement, useEffect } from 'react';
import { ABTestError } from '../error';
import { useABTestStore, useActiveVariant } from '../hooks';
import { addExperimentVariant, emitPlayOnFirstTime, getVariantRandomly, setActiveVariant } from '../utils';
import Variant from './Variant';
const filterVariants = (name, children) => {
    const variants = new Map();
    Children.forEach(children, (element) => {
        if (!isValidElement(element) || element.type.displayName !== Variant.displayName) {
            throw new ABTestError('INVALID_CHILD', 'Experiment children must be Variant components');
        }
        variants.set(element.props.name, element);
        addExperimentVariant(name, element.props.name);
    });
    return variants;
};
const Experiment = ({ name, children, defaultVariantName, userIdentifier, defaultContent, fallback, }) => {
    const filteredVariants = filterVariants(name, children);
    const store = useABTestStore();
    const activeVariantName = useActiveVariant(name);
    // set active variant in memory
    useEffect(() => {
        // If there is an active variant now, don't set anything
        if (activeVariantName) {
            return;
        }
        let ignore = false;
        const getVariant = async () => {
            const value = await store.getItem(name);
            if (ignore) {
                return;
            }
            const variant = value ?? defaultVariantName ?? getVariantRandomly(name, userIdentifier);
            setActiveVariant(name, variant, !!value); // skip saving when local storage is set
            emitPlayOnFirstTime(name, variant);
        };
        getVariant();
        return () => {
            ignore = true;
        };
    }, [store, defaultVariantName, name, userIdentifier, activeVariantName]);
    return <>{activeVariantName == null ? fallback : filteredVariants.get(activeVariantName) ?? defaultContent}</>;
};
Experiment.displayName = 'zoolife.ABTest.Experiment';
export default Experiment;
